export const FONT_FACE_OBSERVER_TIMEOUT = 999999;
export const FONT_LIST = ['Akkurat'];
export const NO_DATA = 'No data';
export const DASH = '-';
export const EMPTY = '';

export const POSITIVE_COLOR = '#4B87CD';
export const ICICLE_COLORS = [POSITIVE_COLOR, '#4172AC', '#385F8C', '#2E4C6E'];

export const ABSOLUTE_MEASURE_TYPE = 'Abs';

export const AUTH_ENABLED = process.env.REACT_APP_AUTH_ENABLED
  ? process.env.REACT_APP_AUTH_ENABLED.toLowerCase() === 'true'
  : false;

export const CHECK_AUTH_TOKEN_TIMING = 5000;

export const MONTHLY_INTERVAL = 24 * 3600 * 1000 * 30;
export const YEAR_INTERVAL = 24 * 3600 * 1000 * 30 * 12;

export const ESCAPE_KEY = 'Escape';
